module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvbWlzdG9ja2RhcmsuNDk3Mjg4MzMucG5nIjs="